import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './SkillDialog.css';
import CancelButton from '../../../../../components/form/CancelButton';
import { Form } from '../../../../../components/form/Form';
import { Input } from '../../../../../components/form/Input';
import SubmitButton from '../../../../../components/form/SubmitButton';
import InputLabel from '../../../../../components/form/InputLabel';
import { IdName } from '../common/types';
import { SkillCategoryPicker } from '../manager/SkillCategoryPicker';
import { CreateUpdateFormData, skillValidationSchema } from './common';

type Props = {
  show: boolean;
  onClose: () => void;
  skill: IdName & { categoryId?: string | null };
  onSubmit: (name: string, categoryId: string | null) => void;
  allSkills: IdName[];
};

export const UpdateSkillDialog: React.FC<React.PropsWithChildren<Props>> = ({
  show,
  onClose,
  onSubmit,
  skill,
  allSkills,
}) => {
  const { t } = useTranslation();
  const defaultValues: CreateUpdateFormData = {
    rateable: '',
    name: skill.name,
    categoryId: skill.categoryId ?? null,
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="skill-dialog-elevated">
      <Form
        defaultValues={defaultValues}
        onSubmit={(form) => onSubmit(form.name, form.categoryId)}
        validationSchema={skillValidationSchema(
          allSkills,
          t('skills.alreadyExists'),
          skill.id,
        )}>
        <Modal.Header closeButton>
          <Modal.Title>{t(`skills.updateSkill.title`)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {t(`skills.updateSkill.description`, { skillName: skill.name })}
          </p>
          <Input
            label={t(`skills.updateSkill.input.label`)}
            placeholder={t(`skills.updateSkill.input.placeholder`)}
            name="name"
            autoFocus={true}
          />
          <div className="mt-3">
            <InputLabel label={t('skills.category.pickerLabel')} />
            <SkillCategoryPicker name="categoryId" />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <CancelButton onClick={onClose}>
            {t('skills.updateSkill.cancel')}
          </CancelButton>
          <SubmitButton>{t('skills.updateSkill.save')}</SubmitButton>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
